import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import AuxiliaryEquipmentDetailsForm from './auxiliary-equipment-details-form';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import AuxiliaryEquipmentMaintenanceHistory from './auxiliary-equipment-maintenance-history';
import SafetyChecklist from './safety-checklist';
import CellHistory from './cell-history';
import SafetyChecklistHistory from './safety-checklist-history';
import EditAuxiliaryEquipment from './edit-auxiliary-equipment';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];

const editKeys = ['changed', 'isDeleted'];

const AuxiliaryEquipmentAddEdit = ({ showModal, modalData, onCloseModal }) => {
  const auxiliaryEquipmentData = modalData;
  const [formData, setFormData] = useState(auxiliaryEquipmentData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData, setSafetyData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  // Debug logging to check the data structure
  console.log('Auxiliary Equipment Modal Data:', modalData);
  console.log('Form Data ID:', formData?.id);
  console.log('Form Data AuxiliaryEquipmentId:', formData?.auxiliaryEquipmentId);

  const dispatch = useDispatch();
  const isEditMode = Boolean(auxiliaryEquipmentData?.id || auxiliaryEquipmentData?.assetNumber);

  const onChangesAuxiliaryEquipmentForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (data, mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }

    if (activeTabIndex === 3 && newTabIndex !== 3) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Auxiliary Equipment">
              <EditAuxiliaryEquipment
                data={formData}
                onChanges={onChangesAuxiliaryEquipmentForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Auxiliary Equipment Maintenance Details">
              <AuxiliaryEquipmentDetailsForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesAuxiliaryEquipmentForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <AuxiliaryEquipmentMaintenanceHistory
                data={formData}
                auxiliaryEquipmentId={formData?.auxiliaryEquipmentId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist 
                auxiliaryEquipmentId={formData?.auxiliaryEquipmentId || formData?.id}
                onCloseModal={handleClose}
                safetyActionRecord={safetyData}
              />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesAuxiliaryEquipmentForm}
                onCloseModal={handleClose}
                auxiliaryEquipmentId={formData?.auxiliaryEquipmentId || formData?.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditAuxiliaryEquipment
            data={formData}
            onChanges={onChangesAuxiliaryEquipmentForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="auxiliary-equipment-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Auxiliary Equipment Maintenance Summary' : 'Add Auxiliary Equipment'}
      body={body}
      handleClose={handleClose}
    />
  );
};

AuxiliaryEquipmentAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(AuxiliaryEquipmentAddEdit);
